import { getSentryConfig } from '../environment';

const sentryConfig = getSentryConfig(window.location);

/**
 * All of the piece within this block are temporary stopgaps until AEM links are fixed
 * TODO: Remove once AEM link APIs are fixed
 * EXCEPTION: Memorials - we need a better setup for checking type
 * -----------------------------------------------------------------------------------
 * */
const DIY_IDS = sentryConfig.diyEventIds || [];
const HEROES_IDS = sentryConfig.heroesEventIds || [];
const IRONMAN_IDS = sentryConfig.ironmanEventIds || [];
const RNR_IDS = sentryConfig.rnrEventIds || [];
const SJMMW_IDS = sentryConfig.sjmmwEventIds || [];
const MEMORIALS_IDS = sentryConfig.memorialsIds || [];

export const fitnessResourceLink =
  'https://www.stjude.org/get-involved/fitness-fundraisers/run.html#train';
export const ironmanResourceLink =
  'https://fundraising.stjude.org/site/SPageNavigator/Heroes/heroes_IRONMAN_70_3_training_plans.html';
export const diyMosaicLink =
  'https://fundraising.stjude.org/site/SPageServer?pagename=diy_mosaic';
export const diyStJudeGraphicLink =
  'https://fundraising.stjude.org/site/SPageServer?pagename=diy_infographic';

export const isDIY = (id: string) => !!DIY_IDS.includes(id);
export const isHeroes = (id: string) => !!HEROES_IDS.includes(id);
export const isIronman = (id: string) => !!IRONMAN_IDS.includes(id);
export const isMemphisMarathon = (id: string) => !!SJMMW_IDS.includes(id);
export const isRockNRoll = (id: string) => !!RNR_IDS.includes(id);
export const isMemorial = (id: string) => !!MEMORIALS_IDS.includes(id);

export const isHeroesType = (id: string) =>
  isHeroes(id) || isIronman(id) || isMemphisMarathon(id) || isRockNRoll(id);

/**
 * End stopgap block
 * -----------------------------------------------------------------------------------
 * */
